import React from 'react';
import { useTranslation } from 'react-i18next';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';

export const VIEW_MODES = ['grid', 'cards'];

const ICONS = {
  grid: <ViewListOutlinedIcon />,
  cards: <ViewModuleOutlinedIcon />,
};

/**
 * Switches a list page between the DataGrid and the card view. Goes in
 * `ListFilterToolbar`'s `endAction`, right after the search; state comes from
 * `useViewMode`.
 */
export default function ViewModeToggle({ value, onChange }) {
  const { t } = useTranslation();

  return (
    <ToggleButtonGroup
      exclusive
      value={value}
      // Clicking the selected button gives `null`: keep the current mode.
      onChange={(event, next) => next && onChange(next)}
      aria-label={t('viewMode.label')}
    >
      {VIEW_MODES.map((mode) => (
        <Tooltip key={mode} title={t(`viewMode.${mode}`)}>
          <ToggleButton value={mode} aria-label={t(`viewMode.${mode}`)}>
            {ICONS[mode]}
          </ToggleButton>
        </Tooltip>
      ))}
    </ToggleButtonGroup>
  );
}
